import {inlineSchema} from './utils';
import * as MemberInGroup from './membership-in-group';
import debug from 'src/debug';

export default function () {
  return {
    group_id: {type: 'id'},
    created_at: {type: 'datetime', readonly: true},
    status: {type: 'select', items: ['status.active', 'status.inactive']},
    type: {type: 'string'},
    tags: {type: 'tags'},
    'details.code': {type: 'label', hidden: true},
    details: {
      type: 'schema',
      expand: true,
      schema: inlineSchema({
        code: {type: 'string'},
        name: {type: 'i18n', itemType: {type: 'string'}},
        description: {type: 'i18n', itemType: {type: 'text'}},
        professional: {type: 'i18n', itemType: {type: 'string'}},
        qualification: {type: 'i18n', itemType: {type: 'string'}},
        target_group: {type: 'i18n', itemType: {type: 'string'}},
        service_location: {type: 'i18n', itemType: {type: 'string'}},
        service_area_short: {type: 'i18n', itemType: {type: 'string'}},
        recommended_hourly_rate: {
          type: 'schema',
          expand: true,
          schema: inlineSchema({
            hkd: {type: 'number'},
            rmb: {type: 'number'},
          }),
        },
      }),
    },
    members: {
      type: 'table', schema: MemberInGroup, label: 'schema.caregivers',
      initialFilter(value, model) {
        return {group_id: model.group_id};
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/schemas/group_db.js